import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/')({
  beforeLoad: () => { throw redirect({ to: '/administration/apps' }); },
});
